<rask-page pageTitle="{{texts.pageHeader}}" contentClass="mb-0">
    <rask-tabs
        parameterName="section"
        layout="header"
        aid="tabs"
        [size]="5"
        class="h-100 flex-column d-flex"
        tabClass="h-100">
        <rask-tab
            label="Sändningslogg"
            routeId="section1">
            <ng-container headerContent>
                <rask-search-panel class="h-100 flex-column d-flex"></rask-search-panel>
            </ng-container>
        </rask-tab>
        <rask-tab
            label="Rensa logg och skicka om filer"
            routeId="section1">
            <ng-container headerContent>
                <rask-search-panel-maskin class="h-100 flex-column d-flex"></rask-search-panel-maskin>
            </ng-container>
        </rask-tab>
    </rask-tabs>
</rask-page>